import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrl, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IQBOPushVendorsDTO from "../models/DTO/IQBOPushVendorsDTO";
import IProcessedBaseDTO from "../models/DTO/IProcessedBaseDTO";
import IQBOConnectVendorsDTO from "@models/DTO/IQBOConnectVendorsDTO";

const pushQboVendors = async (
    options: IQBOPushVendorsDTO,
    userModel: IUserUI,
    supplierModel: ISupplierModel
): Promise<IProcessedBaseDTO> => {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.QBOPushVendors });
    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, {
        method: "POST",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify(options),
    });

    if (!response.ok) {
        throw new Error(`Failed to push vendors: ${response.statusText}`);
    }

    return response.json();
};

const connectQboVendors = async (options: IQBOConnectVendorsDTO, userModel: IUserUI, supplierModel: ISupplierModel) => {
    const url = buildRestUrl({ endpoint: RestEndpointsEnum.QBOConnectVendors });
    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, {
        method: "POST",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify(options),
    });

    if (!response.ok) {
        throw new Error(`Failed to connect vendors: ${response.statusText}`);
    }

    return response.json() as Promise<IProcessedBaseDTO>;
};

const VendorSourceService = {
    pushQboVendors,
    connectQboVendors,
};

export default VendorSourceService;
